import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { request } from '../api';
import { processOAuth } from '../service';

export default function OauthInstall() {
  const { platformName } = useParams();

  useEffect(() => {
    request(`integrations/${platformName}`).then((response) => {
      const queryParams = new URLSearchParams(window.location.search);
      processOAuth(response, queryParams);
    });
  }, [platformName]);

  return <div>Redirecting...</div>;
}
